import * as React from "react"
import { isNetworkRequestInFlight } from "@apollo/client/core/networkStatus"
import { useListCategoriesQuery } from "@digits-graphql/frontend/graphql-bearer"
import { defined } from "@digits-shared/helpers/filters"
import { useMolecule } from "bunshi/react"
import { useSetAtom } from "jotai"
import { newCategoryModalMolecule } from "src/frontend/components/OS/Applications/CategoryManager/CategoryPanel/NewCategoryModal/newCategoryModalMolecule"
import { useViewVersion } from "src/frontend/components/Shared/Contexts/useViewVersion"

export function useHydrateExistingCategoryData() {
  const viewKey = useViewVersion()
  const { existingCategoryNumbersAtom, existingCategoryNamesAtom } =
    useMolecule(newCategoryModalMolecule)
  const setCategoryNumbers = useSetAtom(existingCategoryNumbersAtom)
  const setCategoryNames = useSetAtom(existingCategoryNamesAtom)

  const { data, networkStatus } = useListCategoriesQuery({
    variables: {
      viewKey,
    },
  })

  React.useEffect(() => {
    if (!isNetworkRequestInFlight(networkStatus)) {
      const categoryNumbers = data?.listCategories.map((c) => c.displayNumber).filter(defined) || []
      setCategoryNumbers(new Set(categoryNumbers))

      const categoryNames = data?.listCategories.map((c) => c.name).filter(defined) || []
      setCategoryNames(new Set(categoryNames))
    }
  }, [data, networkStatus, setCategoryNumbers, setCategoryNames])
}
